// EntityAnalysis.jsx

import React, { useEffect } from "react";
import {
  Box,
  IconButton,
  CircularProgress,
  Typography,
  Button,
} from "@mui/material";

import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";

import EntityProfile from "./Entity Profile/EntityProfile";
import ClientPortfolioOverview from "./Client Portfolio/ClientPortfolioOverview";
import ClientEngagementDashboard from "./Client Engagement/ClientEngagementDashboard";
import ChatDrawer from "./ChatDrawer"; // same folder

const EntityAnalysis = ({ ActiveTab, analysis, ToHome }) => {
  const [openChat, setOpenChat] = React.useState(false);

  const handleOpenChat = () => setOpenChat(true);
  const handleCloseChat = () => setOpenChat(false);

  const loading = analysis?.loading;
  const error = analysis?.error;
  const data = analysis?.data;
  const clientName =
    analysis?.clientName || analysis?.data?.client_id || "Client";

  const showContent = !loading && !error && data;

  // 🔥 Scroll to top whenever ActiveTab changes
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [ActiveTab]);

  return (
    <Box
      sx={{
        position: "relative",
        minHeight: "calc(100vh - 72px)",
        bgcolor: "background.default",
        pt: 8,
      }}
    >
      {/* LOADING STATE */}
      {loading && (
        <Box
          sx={{
            minHeight: "calc(100vh - 72px)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
          }}
        >
          <CircularProgress />
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            Analyzing {clientName || "client"} data…
          </Typography>
        </Box>
      )}

      {/* ERROR STATE */}
      {!loading && error && (
        <Box
          sx={{
            minHeight: "calc(100vh - 72px)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
            px: 2,
          }}
        >
          <Typography variant="h6" color="error" sx={{ fontWeight: 600 }}>
            {error}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            You can go back to the home screen and try again.
          </Typography>
          <Button variant="outlined" onClick={() => ToHome()} sx={{ mt: 1 }}>
            Go to Home
          </Button>
        </Box>
      )}

      {/* MAIN CONTENT (only when we have data) */}
      {showContent && (
        <Box sx={{ height: "100%", width: "100%" }}>
          {ActiveTab === "core" && <EntityProfile data={data} />}
          {ActiveTab === "account" && <ClientPortfolioOverview data={data} />}
          {ActiveTab === "marketing" && (
            <ClientEngagementDashboard data={data} />
          )}
        </Box>
      )}

      {/* Floating Chat Icon - hidden when drawer is open */}
      {/* {!openChat && showContent && (
        <IconButton
          onClick={handleOpenChat}
          aria-label="Open entity assistant"
          sx={{
            position: "fixed",
            bottom: 24,
            right: 24,
            zIndex: (theme) => theme.zIndex.drawer + 1,
            width: 56,
            height: 56,
            borderRadius: "999px",
            bgcolor: "primary.main",
            color: "common.white",
            boxShadow: 6,
            transition: "all 0.2s ease",
            "&:hover": {
              bgcolor: "primary.dark",
              transform: "translateY(-2px)",
              boxShadow: 10,
            },
          }}
        >
          <ChatOutlinedIcon />
        </IconButton>
      )} */}

      {/* Right-side Chat Drawer */}
      {/* <ChatDrawer open={openChat} onClose={handleCloseChat} /> */}
    </Box>
  );
};

export default EntityAnalysis;
